//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import I18n from 'i18next';
import _    from 'lodash';

import CustomerFields from '@constants/CustomerFields';

class CustomerHelper {
    static getNameByContactPerson(customer) {
        const firstname = _.get(customer, [CustomerFields.contactPersonOne, CustomerFields.contactPersonFirstname]);
        const lastname  = _.get(customer, [CustomerFields.contactPersonOne, CustomerFields.contactPersonLastname]);

        return I18n.t('screens.customersScreen.fullName', {
            firstname,
            lastname,
        });
    }
}

export default CustomerHelper;
